import { Box } from '@material-ui/core';

import { useAddressContext } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/contexts/AddressContext';
import { useAddressFormFields } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/hooks/useAddressFormFields';
import { AddressMode } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/types/AddressMode';
import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

export const BackToAutocompleteButton = () => {
  const { setMode, setFocusAutocomplete } = useAddressContext();
  const { emptyFields } = useAddressFormFields();

  const handleClick = () => {
    emptyFields();
    setMode(AddressMode.AUTOCOMPLETE);
    setTimeout(() => {
      setFocusAutocomplete(true);
    }, 500);
  };

  return (
    <StandardButton size="small" variant="text" color="default" onClick={handleClick}>
      <Box display={'flex'} gridGap={'6px'} alignItems={'center'}>
        <Icon size={16}>close</Icon>
        <Text tId={'CANCEL'} />
      </Box>
    </StandardButton>
  );
};
